import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';

import navs from './navs';

const onLogout = () => {
  localStorage.clear();
  window.location = '/';
}

const Navigation = ({location: { pathname }}) => (
    <div className="sidebar">
        <nav className="sidebar-nav">
          <ul className="nav">
            {navs.map((nav, index) => (
              <li key={index} className="nav-item">
                <Link className={classNames("nav-link", { active: pathname === nav.route })} to={nav.route}>
                  <i className={nav.icon}/>
                  <span className="text-center">{nav.name}</span>
                </Link>
              </li>))}
          </ul>
        </nav>
        <div className="sidebar-footer cursor-pointer" onClick={onLogout}>
          <div>
            <i className="fa fa-sign-out mr-2"/>
            <span className="text-center">Logout</span>
          </div>
        </div>
      </div>
)

export default withRouter(Navigation);